import { forwardRef, type Ref } from 'react';
import CoreSwitch, { type SwitchProps as CoreSwitchProps } from '@ovpn/ui/switch';
import Label, { type LabelOwnProps } from '@ovpn/ui/label';

import { boxed } from '@sso/shared/hocs';

type SwitchProps = Omit<CoreSwitchProps, 'children'> &
    Omit<LabelOwnProps, 'children' | 'as' | 'size'> & {
        options: { id: string; title: string }[];
    };

function Switch(
    {
        description,
        appearance,
        className,
        layout,
        title,
        dir,

        options,

        ...inputProps
    }: SwitchProps,
    ref: Ref<HTMLInputElement>,
) {
    return (
        <Label
            required={inputProps.required}
            data-testid={inputProps.id}
            description={description}
            appearance={appearance}
            className={className}
            layout={layout}
            title={title}
            dir={dir}
        >
            <CoreSwitch ref={ref} {...inputProps}>
                {options.map(({ title, id }) => (
                    <CoreSwitch.Option style={{ whiteSpace: 'nowrap' }} key={id} id={id}>
                        {title}
                    </CoreSwitch.Option>
                ))}
            </CoreSwitch>
        </Label>
    );
}

export default boxed(forwardRef(Switch));
